import React from "react";
import {useTranslation} from "react-i18next";
import {NavLink} from "react-router-dom";

const Home = () => {
    const {t} = useTranslation();

    const steps = [
        {title: t("step1"), desc: t("step1Desc"), icon: "🚜", delay: 200},
        {title: t("step2"), desc: t("step2Desc"), icon: "⚙️", delay: 400},
        {title: t("step3"), desc: t("step3Desc"), icon: "💲", delay: 600},
        {title: t("step4"), desc: t("step4Desc"), icon: "🤝", delay: 800}
    ];

    return (
        <>
            {/* Hero Section */}
            <section className="hero-section text-center py-5" data-aos="fade-up">
                <h2 className="fw-bold text-danger display-5 mb-3">{t("title")}</h2>
                <p className="lead text-secondary mx-auto mb-4" style={{maxWidth: "700px"}}>{t("description")}</p>
                <div className="d-flex justify-content-center gap-3">
                    <NavLink to={`/configuration`} className="btn btn-danger btn-lg shadow">{t("start")}</NavLink>
                    {/*<button className="btn btn-outline-danger btn-lg">{t("learn")}</button>*/}
                </div>
            </section>

            {/* How It Works */}
            <section className="howitworks-section py-5">
                <h2 className="fw-bold text-center mb-5" data-aos="fade-right">{t("howItWorks")}</h2>
                <div className="container">
                    <div className="row g-4">
                        {steps.map((step, index) => (
                            <div key={index} className="col-md-3 col-sm-6" data-aos="zoom-in"
                                 data-aos-delay={step.delay}>
                                <div className="card h-100 card-custom-1 text-center p-3">
                                    <div className="fs-1 mb-3">{step.icon}</div>
                                    <h5 className="fw-semibold">{step.title}</h5>
                                    <p className="text-muted">{step.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="text-center py-5 bg-danger bg-opacity-10" data-aos="zoom-in">
                <h3 className="fw-bold text-danger mb-3">{t("ctaTitle")}</h3>
                <p className="text-secondary mb-4 mx-auto" style={{maxWidth: "600px"}}>
                    {t("ctaDesc")}
                </p>
                <NavLink to={`/configuration`} className="btn btn-danger btn-lg shadow">{t("ctaButton")}</NavLink>
            </section>
        </>
    );
};

export default Home;
